import React from 'react';
import { useSelector } from 'react-redux';

import ActionHeader from 'client/components/Result/Actions/ActionHeader';
import ActionButton from 'client/components/Result/Actions/ActionButton';

export default function SignUpFormButton({ themeStyle, btnStyle, onClick = () => {} }) {
    const { buttonText, hint } = useSelector(s => s.signUpForm);

    return (
        <ActionHeader title={hint} titleStyle={`color: ${themeStyle.titleColor};`}>
            <ActionButton text={buttonText} btnStyle={btnStyle} onClick={onClick} />
        </ActionHeader>
    );
}
